// todo: move to respective module

import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { ToastService } from '@shared/modules/toast/services/toast.service';
import { RunTimeConfigService } from '@shared/services/run-time-config.service';

@Injectable()
export class BDDErrorHandlerInterceptor implements HttpInterceptor {
  private readonly BDDSwiftBaseURL: string;
  constructor(private toastService: ToastService, private runTimeConfigService: RunTimeConfigService) {
    this.BDDSwiftBaseURL = this.runTimeConfigService.getConfig('baseURLConfig').bddswift.baseURL;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.indexOf(this.BDDSwiftBaseURL) === -1) {
      return next.handle(req);
    }

    return next
      .handle(req)
      .pipe(finalize(() => {}))
      .pipe(
        tap((ev: HttpEvent<any>) => {}),
        catchError(response => {
          if (response instanceof HttpErrorResponse && req.url.indexOf(this.BDDSwiftBaseURL) > -1) {
            if (response.status !== 200) {
              if (response.error && response.error.message) {
                this.toastService.showToast(response.error.message, 'toastError');
              }
            }
          }

          return throwError(response);
        })
      );
  }
}
